<template>
    <div v-if="!userStore.user.id">
        <home-nav-component/>
    </div>
    <div class="pt-4 container-fluid">
        <div class="pt-4">
            <learn-content></learn-content>
        </div>
    </div>

</template>
<script>
import LearnContent from '../LearnContent.vue'
import { useUserStore } from '../../../../stores/UserStore.js'
export default {
    setup(){
        return{
            userStore:useUserStore(),
        }
    },
    components:{
        LearnContent
    }
}
</script>